import { Society } from '../types/reminderPublisherTypes';

// Définition des sociétés disponibles avec labels
export const AVAILABLE_SOCIETIES: Society[] = [
    { id: 2, label: 'Affiches Parisiennes (AP)' },
    { id: 3, label: 'TOUT LYON (LTL)' },
    // { id: 4, label: "L'ESSOR" },
    { id: 5, label: 'LES PUBLICATIONS COMMERCIALES (NPC)' },
    // { id: 6, label: 'Société Nouvelle Le Patriote Beaujolais (LPB)' },
    // { id: 8, label: 'CLAUDE ET GOY (CEG)' },
    // { id: 9, label: 'EUROPROCUREMENT (EPR)' },
    // { id: 10, label: 'AGENCE JURIDIQUE (AJ)' },
    { id: 12, label: 'Legal2Digital (L2D)' },
];

// Définition des étapes du processus
export const STEPS = ['Choix de la société', 'Sélection des fournisseurs', 'Message personnalisé'];
